export default {"src":"/_next/static/media/logo-teal.7e130fe5.svg","height":49,"width":332,"blurWidth":0,"blurHeight":0};